import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import testmonial2 from '../Image/testmonial2.avif'
import testmonial3 from '../Image/testmonial3.avif'
import testmonial4 from '../Image/testmonial4.avif'
import testmonial1 from '../Image/testmonial1.avif'
import testmonial5 from '../Image/testmonial5.avif'
import testmonial6 from '../Image/testmonial6.avif'
import testmonial7 from '../Image/testmonial7.jpg'
import testmonial8 from '../Image/testmonial8.jpg'
import testmonial9 from '../Image/testmonial9.jpg'
import testmonial10 from '../Image/testmonial10.jpeg'
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Rating from '@mui/material/Rating';
import { ImQuotesLeft } from "react-icons/im";
import { ImQuotesRight } from "react-icons/im";
const testimonials = [
  {
    img: testmonial1,
    name: 'Pranaav B V',
    designation: 'Vellore Institute of Technology',
    text:
      'It was a good experience. The interactions both on and off class hours were what really impressed me. Be it any time of the day, both the teacher and the representative are present to clarify your doubts and help you however possible.',
    alt: 'Pranaav B V',
    title: 'Pranaav B V',
  },
  {
    img: testmonial2,
    name: 'Vaibhav Gupta',
    designation: 'SSIPMT RAIPUR CSE',
    text:
      'I like to thank that I was offered exemplary quality training and I was constantly examining my own practice to improve our program overall training of good',
    alt: 'Vaibhav Gupta',
    title: 'Vaibhav Gupta',
  },
  {
    img: testmonial3,
    name: 'Kajal Mishra',
    designation: 'Manav rachna University',
    text:
      'Overall, I found the program to be highly valuable and well-structured, and I appreciate the opportunity to have been a part of it. I am grateful for the mentorship provided throughout the internship.',
    alt: 'Kajal Mishra',
    title: 'Kajal Mishra',
  },
  {
    img: testmonial4,
    name: 'Gagan Deep k',
    designation: 'VVIT CSE',
    text:
      'It was very good experience training in the company and which helped me improve my skills and knowledge. The company provided very good knowledge on the field of training and about new technology in the professional field.',
    alt: 'Gagan deep k',
    title: 'Gagan deep k',
  },
  {
    img: testmonial5,
    name: 'Devesh Kumar',
    designation: 'Dr. V S Institute of Computer Studies',
    text:
      'The training provided by Internselite was conducted in a very professional and highly intellectual way. Our mentor was very helpful and handled the course with utmost professionalism.',
    alt: 'Devesh Kumar',
    title: 'Devesh Kumar',
  },
  {
    img: testmonial6,
    name: 'Abanti Mukherjee',
    designation: 'Techno India University (BCA)',
    text:
      'The feedback that I would like to provide is that is quite good for enhancing the skills of the student which would add to their resume.',
    alt: 'Abanti Mukherjee',
    title: 'Abanti Mukherjee',
  },
  {
    img: testmonial7,
    name: 'Kolan Ritwik Reddy',
    designation: 'Vardhaman College Of Engineering, AI&ML Branch',
    text:
      'I have to thank my course instructors for paving the path for me and showing the right direction to succeed and not only i have learned about NMP and HTTrack but i also learnt how to use them i learned about IP protocols and Fundamentals Of Computer Neural Networks a big thank you to my mentor as well as my course instructor for supporting me during this entire course and helping mr in finishing my minor as well as my major project',
    alt: 'Kolan Ritwik Reddy',
    title: 'Kolan Ritwik Reddy',
  },
  {
    img: testmonial8,
    name: 'Sachin Mishra',
    designation: 'Gl Bajaj and Computer Science',
    text:'Internselite has truly been a transformative experience for me. The platforms comprehensive training programs and access to cutting-edge AI tools have empowered me to delve into the intricate world of data science with confidence. The dedicated instructors provided invaluable guidance, nurturing both my technical skills and professional acumen. The supplementary skill development sessions were particularly enriching, offering practical insights into resume building, interview preparation, and job profile handling. Through InternSelite, I have not only enhanced my technical prowess but also developed the essential soft skills needed to thrive in todays competitive job market. I highly recommend InternSelite to anyone looking to embark on a rewarding journey in the field of AI and data science.',
    alt: 'Sachin Mishra',
    title: 'Sachin Mishra',
  },
  {
    img: testmonial9,
    name: 'Patakunti Lakshmi Bhargav Reddy',
    designation: 'LPU CSE',
    text:
      'it was great session i have with them intercating to them and learning new.',
    alt: 'Patakunti Lakshmi Bhargav Reddy',
    title: 'Patakunti Lakshmi Bhargav Reddy',
  },
  {
    img: testmonial10,
    name: 'Krrish Butola',
    designation: 'University School of Management and Entrepreneurship , Delhi Technological University ',
    text:
      'My Digital Marketing internship at Internslite was invaluable. Working on projects allowed me to apply theoretical knowledge practically, enhancing my skills in content creation and social media analysis. I gained significant hands-on experience with tools like Google Analytics and SEO techniques. A highlight was the mentorship from my supervisor, Sunanda B, whose guidance and feedback were crucial to my growth. Working on the projects introduced me to effective digital marketing tools. Initially, finding project information was challenging, but re-watching instructional videos helped. I also realised the depth of SEO knowledge required and plan to develop further in this area. Overall, this internship provided a solid foundation in digital marketing, preparing me well for my future career. I appreciate the support and opportunities offered by Internslite and am excited to apply what I have learnt in my next role.',
    alt: 'Krrish Butola',
    title: 'Krrish Butola',
  },
]

const Review_Component = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    vertical: true,
    verticalSwiping: true,
  }

  return (
    <>
  {/* ---------------------------Desktop View----------------------- */}
    <div className="container d-xl-block d-none mt-4">
      <div className="row">
        <div className="col-md-6 pt-1">
          <div className='pt-5 textmonial_text'>
            <h1>Testimonials</h1>
            <h2 className='display-3 py-3'>Our Student's are Saying</h2>
            <p>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
          </div>
          <div className='d-flex justify-content-start pt-4'>
          <AvatarGroup max={6}>
          <Avatar alt="Abanti Mukherjee" src={testmonial5} />
            <Avatar alt="Abanti Mukherjee" src={testmonial6} />
            <Avatar alt="Kolan Ritwik Reddy" src={testmonial7} />
            <Avatar alt="Sachin Mishra" src={testmonial8} />
            <Avatar alt="Patakunti Lakshmi Bhargav Reddy" src={testmonial9} />
            <Avatar alt="Krrish Butola" src={testmonial10} />
            <Avatar alt="Remy Sharp" src={testmonial1} />
            <Avatar alt="Travis Howard" src={testmonial2} />
            <Avatar alt="Cindy Baker" src={testmonial3} />
            <Avatar alt="Agnes Walker" src={testmonial4} />
            </AvatarGroup>
          </div>
          <div className='pt-2'>
            <Rating name="half-rating-read" defaultValue={5} precision={4} readOnly />
          </div>
        </div>
        <div className="col-md-6 px-4">
          <div className="">
            <Slider className='testimonial-card-hight' {...settings}>
              {testimonials.map((testimonial, index) => (
                <div
                  className="my-3 testimonial-card px-5 py-3"
                  key={index}
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-3">
                        <div className='d-flex justify-content-start'>
                        <img
                          src={testimonial.img}
                          alt={testimonial.alt}
                          className="profile mt-4"
                        />
                        </div>
                        <div className='pt-2'>
                        <Rating name="size-small" defaultValue={4} size="small" precision={4} />
                        </div>
                      </div>
                      <div className='col-1'></div>
                      <div className="col-8 my-3">
                        <h1 className="name">{testimonial.name}</h1>
                        <h2 className="designation">
                          {testimonial.designation}
                        </h2>
                        <p className="testimonial"><ImQuotesLeft size="15px"/>{' '}{testimonial.text}{' '}<ImQuotesRight size="15px" /></p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  {/* ---------------------------Tab View----------------------- */}
    <div className="container d-md-block d-none d-xl-none">
      <div className="row mt-3">
        <div className="col-md-5 pt-5">
          <div className='textmonial_text'>
            <h1>Testimonials</h1>
            <h2 className='display-4 py-2'>Our Student's are Saying</h2>
            <p>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
          </div>
          <div className='d-flex justify-content-start pt-4'>
          <AvatarGroup max={4}>
            <Avatar alt="Remy Sharp" src={testmonial1} />
            <Avatar alt="Travis Howard" src={testmonial2} />
            <Avatar alt="Cindy Baker" src={testmonial3} />
            <Avatar alt="Agnes Walker" src={testmonial4} />
            <Avatar alt="Trevor Henderson" src={testmonial5} />
            </AvatarGroup>
          </div>
          <div className='pt-2'>
            <Rating name="half-rating-read" defaultValue={5} precision={4} readOnly />
          </div>
        </div>
        <div className="col-md-7">
          <div className="">
            <Slider className='' {...settings}>
              {testimonials.map((testimonial, index) => (
                <div
                  className="my-3 testimonial-card px-5 py-3"
                  key={index}
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-3">
                        <div className='d-flex justify-content-start'>
                        <img
                          src={testimonial.img}
                          alt={testimonial.alt}
                          className="tab_profile mt-4"
                        />
                        </div>
                        <div className='pt-2'>
                        <Rating name="size-small" defaultValue={4} size="small" precision={4} />
                        </div>
                      </div>
                      <div className='col-1'></div>
                      <div className="col-8 my-3">
                        <h1 className="Tab_name">{testimonial.name}</h1>
                        <h2 className="Tab_designation">
                          {testimonial.designation}
                        </h2>
                        <p className="Tab_testimonial"><ImQuotesLeft size="15px"/>{' '}{testimonial.text}{' '}<ImQuotesRight size="15px" /></p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>

  {/* ---------------------------Mobile View----------------------- */}
    <div className="container d-md-none d-sm-block mt-2">
      <div className="row">
        <div className="col-md-12 pt-3 text-center">
          <div className='textmonial_text'>
            <h1>Testimonials</h1>
            <h2 className='display-3 py-2'>Our Student's are Saying</h2>
            <p>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
          </div>
          <div className='d-flex justify-content-center pt-2'>
          <AvatarGroup max={4}>
            <Avatar alt="Remy Sharp" src={testmonial1} />
            <Avatar alt="Travis Howard" src={testmonial2} />
            <Avatar alt="Cindy Baker" src={testmonial3} />
            <Avatar alt="Agnes Walker" src={testmonial4} />
            <Avatar alt="Trevor Henderson" src={testmonial5} />
            </AvatarGroup>
          </div>
          <div className='pt-2'>
            <Rating name="half-rating-read" defaultValue={5} precision={4} readOnly />
          </div>
        </div>
        <div className="col-md-12">
          <div className="">
            <Slider className='' {...settings}>
              {testimonials.map((testimonial, index) => (
                <div
                  className="my-3 testimonial-card px-5 py-3"
                  key={index}
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                        <div className='d-flex justify-content-center'>
                        <img
                          src={testimonial.img}
                          alt={testimonial.alt}
                          className="Mobile_profile mt-4"
                        />
                        </div>
                        <div className='pt-2'>
                        <Rating name="size-small" defaultValue={4} size="small" precision={4} />
                        </div>
                      </div>
                      <div className="col-12 my-3">
                        <h1 className="Tab_name">{testimonial.name}</h1>
                        <h2 className="Tab_designation">
                          {testimonial.designation}
                        </h2>
                        <p className="Tab_testimonial"><ImQuotesLeft size="15px"/>{' '}{testimonial.text}{' '}<ImQuotesRight size="15px" /></p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default Review_Component
